import { useNewVersionCheck } from '@/hooks/ui/useNewVersionCheck';

// Renders nothing; mounts the version check inside the QueryClientProvider.
export const NewVersionPrompt = () => {
  useNewVersionCheck();
  return null;
};